import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'
import { GaussIframe } from './GaussIframe.component'

const withUnmountHoc = withUnmountTransition(GaussIframe)
export { withUnmountHoc as GaussIframe }
